import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import Team from '@/plugins/sdk/resources/Team'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'hideservice'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      team: new ITEM(Team),
      carrier_service: new ITEM(CarrierService)
    }
  }
}
